<template>
  <app-modal
    v-bind="$attrs"
    class="confirm-modal-container"
    contentStyle="min-width:400px"
  >
    <template v-slot:header>
      <v-card-title class="screen-title">設定完了</v-card-title>
    </template>
    <template v-slot:body="{ ok }">
      <!-- BODY -->
      <div class="modal-body pa-4">
        設定反映が完了しました。<br />
        画面を更新して下さい。
      </div>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn color="primary" variant="flat" @click="ok">更新</v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ProvisioningConfirmModal",
});
</script>
